// @generated by protobuf-ts 2.11.1 with parameter long_type_number,generate_dependencies
// @generated from protobuf file "domains/vlp-notification/vlp-notification-delivery-model.proto" (package "vlp.notification", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { eNotificationChannel } from "./vlp-notification-definition-model";
import { eNotificationSeverity } from "./vlp-notification-definition-model";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * Inbox idempotency: mỗi (EventId, Consumer) xử lý đúng một lần — retry không tạo message trùng.
 *
 * @generated from protobuf message vlp.notification.NotificationEventInboxDTO
 */
export interface NotificationEventInboxDTO {
    /**
     * @generated from protobuf field: int64 notification_event_inbox_id = 1
     */
    notificationEventInboxId: number;
    /**
     * @generated from protobuf field: string event_id = 2
     */
    eventId: string; // GUID từ producer outbox
    /**
     * @generated from protobuf field: string consumer = 3
     */
    consumer: string;
    /**
     * @generated from protobuf field: string payload_hash = 4
     */
    payloadHash: string;
    /**
     * @generated from protobuf field: vlp.notification.eNotificationInboxStatus status = 5
     */
    status: eNotificationInboxStatus;
    /**
     * @generated from protobuf field: int32 retry_count = 6
     */
    retryCount: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp processed_at = 7
     */
    processedAt?: Timestamp;
    /**
     * @generated from protobuf field: string last_error = 8
     */
    lastError: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 23
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 24
     */
    updatedAt?: Timestamp;
}
/**
 * Persistent in-app notification (inbox người dùng) + trạng thái tổng hợp delivery.
 *
 * @generated from protobuf message vlp.notification.NotificationMessageDTO
 */
export interface NotificationMessageDTO {
    /**
     * @generated from protobuf field: int64 notification_message_id = 1
     */
    notificationMessageId: number;
    /**
     * @generated from protobuf field: string event_id = 2
     */
    eventId: string;
    /**
     * @generated from protobuf field: int64 tenant_id = 3
     */
    tenantId: number;
    /**
     * @generated from protobuf field: int64 organization_unit_id = 4
     */
    organizationUnitId: number; // 0 = tenant-wide
    /**
     * @generated from protobuf field: int64 notification_definition_id = 5
     */
    notificationDefinitionId: number;
    /**
     * @generated from protobuf field: string definition_code = 6
     */
    definitionCode: string;
    /**
     * @generated from protobuf field: int64 subject_id = 7
     */
    subjectId: number; // id đối tượng nghiệp vụ (shipment/topup/...)
    /**
     * @generated from protobuf field: string subject_type = 8
     */
    subjectType: string; // deep-link FE: loại đối tượng
    /**
     * @generated from protobuf field: vlp.notification.eNotificationSeverity severity = 9
     */
    severity: eNotificationSeverity;
    /**
     * @generated from protobuf field: string title = 10
     */
    title: string;
    /**
     * @generated from protobuf field: string content_snapshot = 11
     */
    contentSnapshot: string; // render sẵn, snapshot template version (audit)
    /**
     * @generated from protobuf field: int64 template_version = 12
     */
    templateVersion: number;
    /**
     * @generated from protobuf field: vlp.notification.eNotificationMessageStatus status = 13
     */
    status: eNotificationMessageStatus;
    /**
     * @generated from protobuf field: int64 account_group_info_id = 14
     */
    accountGroupInfoId: number;
    /**
     * @generated from protobuf field: int64 audience_account_id = 15
     */
    audienceAccountId: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 23
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 24
     */
    updatedAt?: Timestamp;
}
/**
 * Một lần gửi tới MỘT recipient trên MỘT channel; địa chỉ lưu masked (không PII đầy đủ).
 *
 * @generated from protobuf message vlp.notification.NotificationDeliveryDTO
 */
export interface NotificationDeliveryDTO {
    /**
     * @generated from protobuf field: int64 notification_delivery_id = 1
     */
    notificationDeliveryId: number;
    /**
     * @generated from protobuf field: int64 notification_message_id = 2
     */
    notificationMessageId: number;
    /**
     * @generated from protobuf field: int64 recipient_account_id = 3
     */
    recipientAccountId: number;
    /**
     * @generated from protobuf field: string address_snapshot_masked = 4
     */
    addressSnapshotMasked: string; // vd t***@gmail.com / +84***789
    /**
     * @generated from protobuf field: vlp.notification.eNotificationChannel channel = 5
     */
    channel: eNotificationChannel;
    /**
     * @generated from protobuf field: string provider = 6
     */
    provider: string;
    /**
     * @generated from protobuf field: vlp.notification.eNotificationDeliveryStatus status = 7
     */
    status: eNotificationDeliveryStatus;
    /**
     * @generated from protobuf field: int32 attempt_count = 8
     */
    attemptCount: number;
    /**
     * @generated from protobuf field: string last_error_code = 9
     */
    lastErrorCode: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp next_retry_at = 10
     */
    nextRetryAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sent_at = 11
     */
    sentAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp delivered_at = 12
     */
    deliveredAt?: Timestamp;
    /**
     * @generated from protobuf field: bool is_read = 13
     */
    isRead: boolean; // in-app: đã đọc
    /**
     * @generated from protobuf field: google.protobuf.Timestamp read_at = 14
     */
    readAt?: Timestamp;
    /**
     * @generated from protobuf field: string subject_snapshot = 15
     */
    subjectSnapshot: string;
    /**
     * @generated from protobuf field: string content_snapshot = 16
     */
    contentSnapshot: string;
    /**
     * @generated from protobuf field: int64 template_version = 17
     */
    templateVersion: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 23
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 24
     */
    updatedAt?: Timestamp;
}
/**
 * Thiết bị nhận push của MỘT account (mobile). Token do app lấy từ expo-notifications rồi tự đăng ký;
 * server không bao giờ suy ra được token, nên đăng xuất phải gọi Unregister để máy đó thôi nhận push
 * của người vừa rời đi.
 *
 * @generated from protobuf message vlp.notification.NotificationDeviceDTO
 */
export interface NotificationDeviceDTO {
    /**
     * @generated from protobuf field: int64 notification_device_id = 1
     */
    notificationDeviceId: number;
    /**
     * @generated from protobuf field: int64 account_id = 2
     */
    accountId: number;
    /**
     * @generated from protobuf field: int64 tenant_id = 3
     */
    tenantId: number;
    /**
     * @generated from protobuf field: string push_token = 4
     */
    pushToken: string; // ExpoPushToken[...] — duy nhất toàn hệ thống
    /**
     * @generated from protobuf field: string platform = 5
     */
    platform: string; // ios | android
    /**
     * @generated from protobuf field: string device_name = 6
     */
    deviceName: string;
    /**
     * @generated from protobuf field: string app_version = 7
     */
    appVersion: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_seen_at = 8
     */
    lastSeenAt?: Timestamp;
    /**
     * @generated from protobuf field: bool active = 20
     */
    active: boolean;
    /**
     * @generated from protobuf field: bool archive = 21
     */
    archive: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 23
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 24
     */
    updatedAt?: Timestamp;
}
/**
 * Incident vận hành: dedupe theo fingerprint (Tenant+Unit+Definition+SourceId+window).
 *
 * @generated from protobuf message vlp.notification.AlertIncidentDTO
 */
export interface AlertIncidentDTO {
    /**
     * @generated from protobuf field: int64 alert_incident_id = 1
     */
    alertIncidentId: number;
    /**
     * @generated from protobuf field: string alert_fingerprint = 2
     */
    alertFingerprint: string;
    /**
     * @generated from protobuf field: int64 tenant_id = 3
     */
    tenantId: number; // 0 = platform scope
    /**
     * @generated from protobuf field: int64 organization_unit_id = 4
     */
    organizationUnitId: number;
    /**
     * @generated from protobuf field: int64 notification_definition_id = 5
     */
    notificationDefinitionId: number;
    /**
     * @generated from protobuf field: string definition_code = 6
     */
    definitionCode: string;
    /**
     * @generated from protobuf field: vlp.notification.eNotificationSeverity severity = 7
     */
    severity: eNotificationSeverity;
    /**
     * @generated from protobuf field: string summary = 8
     */
    summary: string;
    /**
     * @generated from protobuf field: string source_id = 9
     */
    sourceId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 10
     */
    startedAt?: Timestamp;
    /**
     * @generated from protobuf field: string acknowledged_by = 11
     */
    acknowledgedBy: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp acknowledged_at = 12
     */
    acknowledgedAt?: Timestamp;
    /**
     * @generated from protobuf field: int32 escalation_level = 13
     */
    escalationLevel: number;
    /**
     * @generated from protobuf field: vlp.notification.eAlertIncidentState state = 14
     */
    state: eAlertIncidentState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp resolved_at = 15
     */
    resolvedAt?: Timestamp;
    /**
     * @generated from protobuf field: string resolved_by = 16
     */
    resolvedBy: string;
    /**
     * @generated from protobuf field: string rca_reference = 17
     */
    rcaReference: string;
    /**
     * @generated from protobuf field: int32 occurrence_count = 18
     */
    occurrenceCount: number; // số lần alert lặp trong cùng incident
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 23
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 24
     */
    updatedAt?: Timestamp;
}
/**
 * Silence/Maintenance window: có thời hạn, lý do, người duyệt, audit; P1 security không silence được.
 *
 * @generated from protobuf message vlp.notification.AlertSilenceDTO
 */
export interface AlertSilenceDTO {
    /**
     * @generated from protobuf field: int64 alert_silence_id = 1
     */
    alertSilenceId: number;
    /**
     * @generated from protobuf field: vlp.notification.eAlertSilenceKind kind = 2
     */
    kind: eAlertSilenceKind;
    /**
     * @generated from protobuf field: int64 tenant_id = 3
     */
    tenantId: number; // 0 = platform
    /**
     * @generated from protobuf field: int64 organization_unit_id = 4
     */
    organizationUnitId: number;
    /**
     * @generated from protobuf field: string definition_code_matcher = 5
     */
    definitionCodeMatcher: string; // "" = mọi definition trong scope (trừ mandatory security)
    /**
     * @generated from protobuf field: google.protobuf.Timestamp from_at = 6
     */
    fromAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp to_at = 7
     */
    toAt?: Timestamp;
    /**
     * @generated from protobuf field: string reason = 8
     */
    reason: string;
    /**
     * @generated from protobuf field: string approved_by = 9
     */
    approvedBy: string;
    /**
     * @generated from protobuf field: bool active = 20
     */
    active: boolean;
    /**
     * @generated from protobuf field: bool archive = 21
     */
    archive: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 23
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 24
     */
    updatedAt?: Timestamp;
}
// =====================================================================
// LUL-653 — Notification: runtime message/delivery/incident/inbox/silence.
// Schema: Notification.
// =====================================================================

/**
 * @generated from protobuf enum vlp.notification.eNotificationMessageStatus
 */
export enum eNotificationMessageStatus {
    /**
     * @generated from protobuf enum value: NOTIFICATION_MESSAGE_STATUS_UNSPECIFIED = 0;
     */
    NOTIFICATION_MESSAGE_STATUS_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NOTIFICATION_MESSAGE_STATUS_NEW = 1;
     */
    NOTIFICATION_MESSAGE_STATUS_NEW = 1,
    /**
     * @generated from protobuf enum value: NOTIFICATION_MESSAGE_STATUS_DELIVERED = 2;
     */
    NOTIFICATION_MESSAGE_STATUS_DELIVERED = 2,
    /**
     * @generated from protobuf enum value: NOTIFICATION_MESSAGE_STATUS_PARTIALLY_DELIVERED = 3;
     */
    NOTIFICATION_MESSAGE_STATUS_PARTIALLY_DELIVERED = 3,
    /**
     * @generated from protobuf enum value: NOTIFICATION_MESSAGE_STATUS_FAILED = 4;
     */
    NOTIFICATION_MESSAGE_STATUS_FAILED = 4
}
/**
 * @generated from protobuf enum vlp.notification.eNotificationDeliveryStatus
 */
export enum eNotificationDeliveryStatus {
    /**
     * @generated from protobuf enum value: NOTIFICATION_DELIVERY_STATUS_UNSPECIFIED = 0;
     */
    NOTIFICATION_DELIVERY_STATUS_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NOTIFICATION_DELIVERY_STATUS_PENDING = 1;
     */
    NOTIFICATION_DELIVERY_STATUS_PENDING = 1,
    /**
     * @generated from protobuf enum value: NOTIFICATION_DELIVERY_STATUS_SENDING = 2;
     */
    NOTIFICATION_DELIVERY_STATUS_SENDING = 2,
    /**
     * @generated from protobuf enum value: NOTIFICATION_DELIVERY_STATUS_SENT = 3;
     */
    NOTIFICATION_DELIVERY_STATUS_SENT = 3,
    /**
     * @generated from protobuf enum value: NOTIFICATION_DELIVERY_STATUS_DELIVERED = 4;
     */
    NOTIFICATION_DELIVERY_STATUS_DELIVERED = 4,
    /**
     * @generated from protobuf enum value: NOTIFICATION_DELIVERY_STATUS_FAILED = 5;
     */
    NOTIFICATION_DELIVERY_STATUS_FAILED = 5,
    /**
     * retry exhausted -> DLQ, cần xử lý tay
     *
     * @generated from protobuf enum value: NOTIFICATION_DELIVERY_STATUS_DEAD_LETTER = 6;
     */
    NOTIFICATION_DELIVERY_STATUS_DEAD_LETTER = 6
}
/**
 * @generated from protobuf enum vlp.notification.eNotificationInboxStatus
 */
export enum eNotificationInboxStatus {
    /**
     * @generated from protobuf enum value: NOTIFICATION_INBOX_STATUS_UNSPECIFIED = 0;
     */
    NOTIFICATION_INBOX_STATUS_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NOTIFICATION_INBOX_STATUS_PENDING = 1;
     */
    NOTIFICATION_INBOX_STATUS_PENDING = 1,
    /**
     * @generated from protobuf enum value: NOTIFICATION_INBOX_STATUS_PROCESSED = 2;
     */
    NOTIFICATION_INBOX_STATUS_PROCESSED = 2,
    /**
     * @generated from protobuf enum value: NOTIFICATION_INBOX_STATUS_FAILED = 3;
     */
    NOTIFICATION_INBOX_STATUS_FAILED = 3,
    /**
     * @generated from protobuf enum value: NOTIFICATION_INBOX_STATUS_SKIPPED_DUPLICATE = 4;
     */
    NOTIFICATION_INBOX_STATUS_SKIPPED_DUPLICATE = 4
}
/**
 * @generated from protobuf enum vlp.notification.eAlertIncidentState
 */
export enum eAlertIncidentState {
    /**
     * @generated from protobuf enum value: ALERT_INCIDENT_STATE_UNSPECIFIED = 0;
     */
    ALERT_INCIDENT_STATE_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ALERT_INCIDENT_STATE_OPEN = 1;
     */
    ALERT_INCIDENT_STATE_OPEN = 1,
    /**
     * @generated from protobuf enum value: ALERT_INCIDENT_STATE_ACKNOWLEDGED = 2;
     */
    ALERT_INCIDENT_STATE_ACKNOWLEDGED = 2,
    /**
     * @generated from protobuf enum value: ALERT_INCIDENT_STATE_ESCALATED = 3;
     */
    ALERT_INCIDENT_STATE_ESCALATED = 3,
    /**
     * @generated from protobuf enum value: ALERT_INCIDENT_STATE_RESOLVED = 4;
     */
    ALERT_INCIDENT_STATE_RESOLVED = 4
}
/**
 * @generated from protobuf enum vlp.notification.eAlertSilenceKind
 */
export enum eAlertSilenceKind {
    /**
     * @generated from protobuf enum value: ALERT_SILENCE_KIND_UNSPECIFIED = 0;
     */
    ALERT_SILENCE_KIND_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ALERT_SILENCE_KIND_SILENCE = 1;
     */
    ALERT_SILENCE_KIND_SILENCE = 1,
    /**
     * @generated from protobuf enum value: ALERT_SILENCE_KIND_MAINTENANCE_WINDOW = 2;
     */
    ALERT_SILENCE_KIND_MAINTENANCE_WINDOW = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class NotificationEventInboxDTO$Type extends MessageType<NotificationEventInboxDTO> {
    constructor() {
        super("vlp.notification.NotificationEventInboxDTO", [
            { no: 1, name: "notification_event_inbox_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "consumer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "payload_hash", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "status", kind: "enum", T: () => ["vlp.notification.eNotificationInboxStatus", eNotificationInboxStatus] },
            { no: 6, name: "retry_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "processed_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "last_error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<NotificationEventInboxDTO>): NotificationEventInboxDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationEventInboxId = 0;
        message.eventId = "";
        message.consumer = "";
        message.payloadHash = "";
        message.status = 0;
        message.retryCount = 0;
        message.lastError = "";
        if (value !== undefined)
            reflectionMergePartial<NotificationEventInboxDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationEventInboxDTO): NotificationEventInboxDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_event_inbox_id */ 1:
                    message.notificationEventInboxId = reader.int64().toNumber();
                    break;
                case /* string event_id */ 2:
                    message.eventId = reader.string();
                    break;
                case /* string consumer */ 3:
                    message.consumer = reader.string();
                    break;
                case /* string payload_hash */ 4:
                    message.payloadHash = reader.string();
                    break;
                case /* vlp.notification.eNotificationInboxStatus status */ 5:
                    message.status = reader.int32();
                    break;
                case /* int32 retry_count */ 6:
                    message.retryCount = reader.int32();
                    break;
                case /* google.protobuf.Timestamp processed_at */ 7:
                    message.processedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.processedAt);
                    break;
                case /* string last_error */ 8:
                    message.lastError = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 23:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 24:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationEventInboxDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_event_inbox_id = 1; */
        if (message.notificationEventInboxId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationEventInboxId);
        /* string event_id = 2; */
        if (message.eventId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.eventId);
        /* string consumer = 3; */
        if (message.consumer !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.consumer);
        /* string payload_hash = 4; */
        if (message.payloadHash !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.payloadHash);
        /* vlp.notification.eNotificationInboxStatus status = 5; */
        if (message.status !== 0)
            writer.tag(5, WireType.Varint).int32(message.status);
        /* int32 retry_count = 6; */
        if (message.retryCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.retryCount);
        /* google.protobuf.Timestamp processed_at = 7; */
        if (message.processedAt)
            Timestamp.internalBinaryWrite(message.processedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string last_error = 8; */
        if (message.lastError !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.lastError);
        /* google.protobuf.Timestamp created_at = 23; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 24; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationEventInboxDTO
 */
export const NotificationEventInboxDTO = new NotificationEventInboxDTO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationMessageDTO$Type extends MessageType<NotificationMessageDTO> {
    constructor() {
        super("vlp.notification.NotificationMessageDTO", [
            { no: 1, name: "notification_message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tenant_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "organization_unit_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "notification_definition_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 6, name: "definition_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "subject_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 8, name: "subject_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "severity", kind: "enum", T: () => ["vlp.notification.eNotificationSeverity", eNotificationSeverity] },
            { no: 10, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "content_snapshot", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "template_version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 13, name: "status", kind: "enum", T: () => ["vlp.notification.eNotificationMessageStatus", eNotificationMessageStatus] },
            { no: 14, name: "account_group_info_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 15, name: "audience_account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 23, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<NotificationMessageDTO>): NotificationMessageDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationMessageId = 0;
        message.eventId = "";
        message.tenantId = 0;
        message.organizationUnitId = 0;
        message.notificationDefinitionId = 0;
        message.definitionCode = "";
        message.subjectId = 0;
        message.subjectType = "";
        message.severity = 0;
        message.title = "";
        message.contentSnapshot = "";
        message.templateVersion = 0;
        message.status = 0;
        message.accountGroupInfoId = 0;
        message.audienceAccountId = 0;
        if (value !== undefined)
            reflectionMergePartial<NotificationMessageDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationMessageDTO): NotificationMessageDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_message_id */ 1:
                    message.notificationMessageId = reader.int64().toNumber();
                    break;
                case /* string event_id */ 2:
                    message.eventId = reader.string();
                    break;
                case /* int64 tenant_id */ 3:
                    message.tenantId = reader.int64().toNumber();
                    break;
                case /* int64 organization_unit_id */ 4:
                    message.organizationUnitId = reader.int64().toNumber();
                    break;
                case /* int64 notification_definition_id */ 5:
                    message.notificationDefinitionId = reader.int64().toNumber();
                    break;
                case /* string definition_code */ 6:
                    message.definitionCode = reader.string();
                    break;
                case /* int64 subject_id */ 7:
                    message.subjectId = reader.int64().toNumber();
                    break;
                case /* string subject_type */ 8:
                    message.subjectType = reader.string();
                    break;
                case /* vlp.notification.eNotificationSeverity severity */ 9:
                    message.severity = reader.int32();
                    break;
                case /* string title */ 10:
                    message.title = reader.string();
                    break;
                case /* string content_snapshot */ 11:
                    message.contentSnapshot = reader.string();
                    break;
                case /* int64 template_version */ 12:
                    message.templateVersion = reader.int64().toNumber();
                    break;
                case /* vlp.notification.eNotificationMessageStatus status */ 13:
                    message.status = reader.int32();
                    break;
                case /* int64 account_group_info_id */ 14:
                    message.accountGroupInfoId = reader.int64().toNumber();
                    break;
                case /* int64 audience_account_id */ 15:
                    message.audienceAccountId = reader.int64().toNumber();
                    break;
                case /* google.protobuf.Timestamp created_at */ 23:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 24:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationMessageDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_message_id = 1; */
        if (message.notificationMessageId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationMessageId);
        /* string event_id = 2; */
        if (message.eventId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.eventId);
        /* int64 tenant_id = 3; */
        if (message.tenantId !== 0)
            writer.tag(3, WireType.Varint).int64(message.tenantId);
        /* int64 organization_unit_id = 4; */
        if (message.organizationUnitId !== 0)
            writer.tag(4, WireType.Varint).int64(message.organizationUnitId);
        /* int64 notification_definition_id = 5; */
        if (message.notificationDefinitionId !== 0)
            writer.tag(5, WireType.Varint).int64(message.notificationDefinitionId);
        /* string definition_code = 6; */
        if (message.definitionCode !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.definitionCode);
        /* int64 subject_id = 7; */
        if (message.subjectId !== 0)
            writer.tag(7, WireType.Varint).int64(message.subjectId);
        /* string subject_type = 8; */
        if (message.subjectType !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.subjectType);
        /* vlp.notification.eNotificationSeverity severity = 9; */
        if (message.severity !== 0)
            writer.tag(9, WireType.Varint).int32(message.severity);
        /* string title = 10; */
        if (message.title !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.title);
        /* string content_snapshot = 11; */
        if (message.contentSnapshot !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.contentSnapshot);
        /* int64 template_version = 12; */
        if (message.templateVersion !== 0)
            writer.tag(12, WireType.Varint).int64(message.templateVersion);
        /* vlp.notification.eNotificationMessageStatus status = 13; */
        if (message.status !== 0)
            writer.tag(13, WireType.Varint).int32(message.status);
        /* int64 account_group_info_id = 14; */
        if (message.accountGroupInfoId !== 0)
            writer.tag(14, WireType.Varint).int64(message.accountGroupInfoId);
        /* int64 audience_account_id = 15; */
        if (message.audienceAccountId !== 0)
            writer.tag(15, WireType.Varint).int64(message.audienceAccountId);
        /* google.protobuf.Timestamp created_at = 23; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 24; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationMessageDTO
 */
export const NotificationMessageDTO = new NotificationMessageDTO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationDeliveryDTO$Type extends MessageType<NotificationDeliveryDTO> {
    constructor() {
        super("vlp.notification.NotificationDeliveryDTO", [
            { no: 1, name: "notification_delivery_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "notification_message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "recipient_account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "address_snapshot_masked", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "channel", kind: "enum", T: () => ["vlp.notification.eNotificationChannel", eNotificationChannel] },
            { no: 6, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "status", kind: "enum", T: () => ["vlp.notification.eNotificationDeliveryStatus", eNotificationDeliveryStatus] },
            { no: 8, name: "attempt_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "last_error_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "next_retry_at", kind: "message", T: () => Timestamp },
            { no: 11, name: "sent_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "delivered_at", kind: "message", T: () => Timestamp },
            { no: 13, name: "is_read", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "read_at", kind: "message", T: () => Timestamp },
            { no: 15, name: "subject_snapshot", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "content_snapshot", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "template_version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 23, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<NotificationDeliveryDTO>): NotificationDeliveryDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationDeliveryId = 0;
        message.notificationMessageId = 0;
        message.recipientAccountId = 0;
        message.addressSnapshotMasked = "";
        message.channel = 0;
        message.provider = "";
        message.status = 0;
        message.attemptCount = 0;
        message.lastErrorCode = "";
        message.isRead = false;
        message.subjectSnapshot = "";
        message.contentSnapshot = "";
        message.templateVersion = 0;
        if (value !== undefined)
            reflectionMergePartial<NotificationDeliveryDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationDeliveryDTO): NotificationDeliveryDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_delivery_id */ 1:
                    message.notificationDeliveryId = reader.int64().toNumber();
                    break;
                case /* int64 notification_message_id */ 2:
                    message.notificationMessageId = reader.int64().toNumber();
                    break;
                case /* int64 recipient_account_id */ 3:
                    message.recipientAccountId = reader.int64().toNumber();
                    break;
                case /* string address_snapshot_masked */ 4:
                    message.addressSnapshotMasked = reader.string();
                    break;
                case /* vlp.notification.eNotificationChannel channel */ 5:
                    message.channel = reader.int32();
                    break;
                case /* string provider */ 6:
                    message.provider = reader.string();
                    break;
                case /* vlp.notification.eNotificationDeliveryStatus status */ 7:
                    message.status = reader.int32();
                    break;
                case /* int32 attempt_count */ 8:
                    message.attemptCount = reader.int32();
                    break;
                case /* string last_error_code */ 9:
                    message.lastErrorCode = reader.string();
                    break;
                case /* google.protobuf.Timestamp next_retry_at */ 10:
                    message.nextRetryAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.nextRetryAt);
                    break;
                case /* google.protobuf.Timestamp sent_at */ 11:
                    message.sentAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.sentAt);
                    break;
                case /* google.protobuf.Timestamp delivered_at */ 12:
                    message.deliveredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deliveredAt);
                    break;
                case /* bool is_read */ 13:
                    message.isRead = reader.bool();
                    break;
                case /* google.protobuf.Timestamp read_at */ 14:
                    message.readAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.readAt);
                    break;
                case /* string subject_snapshot */ 15:
                    message.subjectSnapshot = reader.string();
                    break;
                case /* string content_snapshot */ 16:
                    message.contentSnapshot = reader.string();
                    break;
                case /* int64 template_version */ 17:
                    message.templateVersion = reader.int64().toNumber();
                    break;
                case /* google.protobuf.Timestamp created_at */ 23:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 24:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationDeliveryDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_delivery_id = 1; */
        if (message.notificationDeliveryId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationDeliveryId);
        /* int64 notification_message_id = 2; */
        if (message.notificationMessageId !== 0)
            writer.tag(2, WireType.Varint).int64(message.notificationMessageId);
        /* int64 recipient_account_id = 3; */
        if (message.recipientAccountId !== 0)
            writer.tag(3, WireType.Varint).int64(message.recipientAccountId);
        /* string address_snapshot_masked = 4; */
        if (message.addressSnapshotMasked !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.addressSnapshotMasked);
        /* vlp.notification.eNotificationChannel channel = 5; */
        if (message.channel !== 0)
            writer.tag(5, WireType.Varint).int32(message.channel);
        /* string provider = 6; */
        if (message.provider !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.provider);
        /* vlp.notification.eNotificationDeliveryStatus status = 7; */
        if (message.status !== 0)
            writer.tag(7, WireType.Varint).int32(message.status);
        /* int32 attempt_count = 8; */
        if (message.attemptCount !== 0)
            writer.tag(8, WireType.Varint).int32(message.attemptCount);
        /* string last_error_code = 9; */
        if (message.lastErrorCode !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.lastErrorCode);
        /* google.protobuf.Timestamp next_retry_at = 10; */
        if (message.nextRetryAt)
            Timestamp.internalBinaryWrite(message.nextRetryAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sent_at = 11; */
        if (message.sentAt)
            Timestamp.internalBinaryWrite(message.sentAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp delivered_at = 12; */
        if (message.deliveredAt)
            Timestamp.internalBinaryWrite(message.deliveredAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* bool is_read = 13; */
        if (message.isRead !== false)
            writer.tag(13, WireType.Varint).bool(message.isRead);
        /* google.protobuf.Timestamp read_at = 14; */
        if (message.readAt)
            Timestamp.internalBinaryWrite(message.readAt, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* string subject_snapshot = 15; */
        if (message.subjectSnapshot !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.subjectSnapshot);
        /* string content_snapshot = 16; */
        if (message.contentSnapshot !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.contentSnapshot);
        /* int64 template_version = 17; */
        if (message.templateVersion !== 0)
            writer.tag(17, WireType.Varint).int64(message.templateVersion);
        /* google.protobuf.Timestamp created_at = 23; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 24; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationDeliveryDTO
 */
export const NotificationDeliveryDTO = new NotificationDeliveryDTO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationDeviceDTO$Type extends MessageType<NotificationDeviceDTO> {
    constructor() {
        super("vlp.notification.NotificationDeviceDTO", [
            { no: 1, name: "notification_device_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "tenant_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "push_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "platform", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "device_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "app_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "last_seen_at", kind: "message", T: () => Timestamp },
            { no: 20, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "archive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<NotificationDeviceDTO>): NotificationDeviceDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationDeviceId = 0;
        message.accountId = 0;
        message.tenantId = 0;
        message.pushToken = "";
        message.platform = "";
        message.deviceName = "";
        message.appVersion = "";
        message.active = false;
        message.archive = false;
        if (value !== undefined)
            reflectionMergePartial<NotificationDeviceDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationDeviceDTO): NotificationDeviceDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_device_id */ 1:
                    message.notificationDeviceId = reader.int64().toNumber();
                    break;
                case /* int64 account_id */ 2:
                    message.accountId = reader.int64().toNumber();
                    break;
                case /* int64 tenant_id */ 3:
                    message.tenantId = reader.int64().toNumber();
                    break;
                case /* string push_token */ 4:
                    message.pushToken = reader.string();
                    break;
                case /* string platform */ 5:
                    message.platform = reader.string();
                    break;
                case /* string device_name */ 6:
                    message.deviceName = reader.string();
                    break;
                case /* string app_version */ 7:
                    message.appVersion = reader.string();
                    break;
                case /* google.protobuf.Timestamp last_seen_at */ 8:
                    message.lastSeenAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastSeenAt);
                    break;
                case /* bool active */ 20:
                    message.active = reader.bool();
                    break;
                case /* bool archive */ 21:
                    message.archive = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 23:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 24:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationDeviceDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_device_id = 1; */
        if (message.notificationDeviceId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationDeviceId);
        /* int64 account_id = 2; */
        if (message.accountId !== 0)
            writer.tag(2, WireType.Varint).int64(message.accountId);
        /* int64 tenant_id = 3; */
        if (message.tenantId !== 0)
            writer.tag(3, WireType.Varint).int64(message.tenantId);
        /* string push_token = 4; */
        if (message.pushToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pushToken);
        /* string platform = 5; */
        if (message.platform !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.platform);
        /* string device_name = 6; */
        if (message.deviceName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.deviceName);
        /* string app_version = 7; */
        if (message.appVersion !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.appVersion);
        /* google.protobuf.Timestamp last_seen_at = 8; */
        if (message.lastSeenAt)
            Timestamp.internalBinaryWrite(message.lastSeenAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool active = 20; */
        if (message.active !== false)
            writer.tag(20, WireType.Varint).bool(message.active);
        /* bool archive = 21; */
        if (message.archive !== false)
            writer.tag(21, WireType.Varint).bool(message.archive);
        /* google.protobuf.Timestamp created_at = 23; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 24; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationDeviceDTO
 */
export const NotificationDeviceDTO = new NotificationDeviceDTO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlertIncidentDTO$Type extends MessageType<AlertIncidentDTO> {
    constructor() {
        super("vlp.notification.AlertIncidentDTO", [
            { no: 1, name: "alert_incident_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "alert_fingerprint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tenant_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "organization_unit_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "notification_definition_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 6, name: "definition_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "severity", kind: "enum", T: () => ["vlp.notification.eNotificationSeverity", eNotificationSeverity] },
            { no: 8, name: "summary", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "source_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "started_at", kind: "message", T: () => Timestamp },
            { no: 11, name: "acknowledged_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "acknowledged_at", kind: "message", T: () => Timestamp },
            { no: 13, name: "escalation_level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "state", kind: "enum", T: () => ["vlp.notification.eAlertIncidentState", eAlertIncidentState] },
            { no: 15, name: "resolved_at", kind: "message", T: () => Timestamp },
            { no: 16, name: "resolved_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "rca_reference", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "occurrence_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<AlertIncidentDTO>): AlertIncidentDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.alertIncidentId = 0;
        message.alertFingerprint = "";
        message.tenantId = 0;
        message.organizationUnitId = 0;
        message.notificationDefinitionId = 0;
        message.definitionCode = "";
        message.severity = 0;
        message.summary = "";
        message.sourceId = "";
        message.acknowledgedBy = "";
        message.escalationLevel = 0;
        message.state = 0;
        message.resolvedBy = "";
        message.rcaReference = "";
        message.occurrenceCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AlertIncidentDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AlertIncidentDTO): AlertIncidentDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 alert_incident_id */ 1:
                    message.alertIncidentId = reader.int64().toNumber();
                    break;
                case /* string alert_fingerprint */ 2:
                    message.alertFingerprint = reader.string();
                    break;
                case /* int64 tenant_id */ 3:
                    message.tenantId = reader.int64().toNumber();
                    break;
                case /* int64 organization_unit_id */ 4:
                    message.organizationUnitId = reader.int64().toNumber();
                    break;
                case /* int64 notification_definition_id */ 5:
                    message.notificationDefinitionId = reader.int64().toNumber();
                    break;
                case /* string definition_code */ 6:
                    message.definitionCode = reader.string();
                    break;
                case /* vlp.notification.eNotificationSeverity severity */ 7:
                    message.severity = reader.int32();
                    break;
                case /* string summary */ 8:
                    message.summary = reader.string();
                    break;
                case /* string source_id */ 9:
                    message.sourceId = reader.string();
                    break;
                case /* google.protobuf.Timestamp started_at */ 10:
                    message.startedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startedAt);
                    break;
                case /* string acknowledged_by */ 11:
                    message.acknowledgedBy = reader.string();
                    break;
                case /* google.protobuf.Timestamp acknowledged_at */ 12:
                    message.acknowledgedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.acknowledgedAt);
                    break;
                case /* int32 escalation_level */ 13:
                    message.escalationLevel = reader.int32();
                    break;
                case /* vlp.notification.eAlertIncidentState state */ 14:
                    message.state = reader.int32();
                    break;
                case /* google.protobuf.Timestamp resolved_at */ 15:
                    message.resolvedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.resolvedAt);
                    break;
                case /* string resolved_by */ 16:
                    message.resolvedBy = reader.string();
                    break;
                case /* string rca_reference */ 17:
                    message.rcaReference = reader.string();
                    break;
                case /* int32 occurrence_count */ 18:
                    message.occurrenceCount = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 23:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 24:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AlertIncidentDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 alert_incident_id = 1; */
        if (message.alertIncidentId !== 0)
            writer.tag(1, WireType.Varint).int64(message.alertIncidentId);
        /* string alert_fingerprint = 2; */
        if (message.alertFingerprint !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.alertFingerprint);
        /* int64 tenant_id = 3; */
        if (message.tenantId !== 0)
            writer.tag(3, WireType.Varint).int64(message.tenantId);
        /* int64 organization_unit_id = 4; */
        if (message.organizationUnitId !== 0)
            writer.tag(4, WireType.Varint).int64(message.organizationUnitId);
        /* int64 notification_definition_id = 5; */
        if (message.notificationDefinitionId !== 0)
            writer.tag(5, WireType.Varint).int64(message.notificationDefinitionId);
        /* string definition_code = 6; */
        if (message.definitionCode !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.definitionCode);
        /* vlp.notification.eNotificationSeverity severity = 7; */
        if (message.severity !== 0)
            writer.tag(7, WireType.Varint).int32(message.severity);
        /* string summary = 8; */
        if (message.summary !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.summary);
        /* string source_id = 9; */
        if (message.sourceId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.sourceId);
        /* google.protobuf.Timestamp started_at = 10; */
        if (message.startedAt)
            Timestamp.internalBinaryWrite(message.startedAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string acknowledged_by = 11; */
        if (message.acknowledgedBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.acknowledgedBy);
        /* google.protobuf.Timestamp acknowledged_at = 12; */
        if (message.acknowledgedAt)
            Timestamp.internalBinaryWrite(message.acknowledgedAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* int32 escalation_level = 13; */
        if (message.escalationLevel !== 0)
            writer.tag(13, WireType.Varint).int32(message.escalationLevel);
        /* vlp.notification.eAlertIncidentState state = 14; */
        if (message.state !== 0)
            writer.tag(14, WireType.Varint).int32(message.state);
        /* google.protobuf.Timestamp resolved_at = 15; */
        if (message.resolvedAt)
            Timestamp.internalBinaryWrite(message.resolvedAt, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* string resolved_by = 16; */
        if (message.resolvedBy !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.resolvedBy);
        /* string rca_reference = 17; */
        if (message.rcaReference !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.rcaReference);
        /* int32 occurrence_count = 18; */
        if (message.occurrenceCount !== 0)
            writer.tag(18, WireType.Varint).int32(message.occurrenceCount);
        /* google.protobuf.Timestamp created_at = 23; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 24; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.AlertIncidentDTO
 */
export const AlertIncidentDTO = new AlertIncidentDTO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlertSilenceDTO$Type extends MessageType<AlertSilenceDTO> {
    constructor() {
        super("vlp.notification.AlertSilenceDTO", [
            { no: 1, name: "alert_silence_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "kind", kind: "enum", T: () => ["vlp.notification.eAlertSilenceKind", eAlertSilenceKind] },
            { no: 3, name: "tenant_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "organization_unit_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "definition_code_matcher", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "from_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "to_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "approved_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "archive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<AlertSilenceDTO>): AlertSilenceDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.alertSilenceId = 0;
        message.kind = 0;
        message.tenantId = 0;
        message.organizationUnitId = 0;
        message.definitionCodeMatcher = "";
        message.reason = "";
        message.approvedBy = "";
        message.active = false;
        message.archive = false;
        if (value !== undefined)
            reflectionMergePartial<AlertSilenceDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AlertSilenceDTO): AlertSilenceDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 alert_silence_id */ 1:
                    message.alertSilenceId = reader.int64().toNumber();
                    break;
                case /* vlp.notification.eAlertSilenceKind kind */ 2:
                    message.kind = reader.int32();
                    break;
                case /* int64 tenant_id */ 3:
                    message.tenantId = reader.int64().toNumber();
                    break;
                case /* int64 organization_unit_id */ 4:
                    message.organizationUnitId = reader.int64().toNumber();
                    break;
                case /* string definition_code_matcher */ 5:
                    message.definitionCodeMatcher = reader.string();
                    break;
                case /* google.protobuf.Timestamp from_at */ 6:
                    message.fromAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.fromAt);
                    break;
                case /* google.protobuf.Timestamp to_at */ 7:
                    message.toAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.toAt);
                    break;
                case /* string reason */ 8:
                    message.reason = reader.string();
                    break;
                case /* string approved_by */ 9:
                    message.approvedBy = reader.string();
                    break;
                case /* bool active */ 20:
                    message.active = reader.bool();
                    break;
                case /* bool archive */ 21:
                    message.archive = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 23:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 24:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AlertSilenceDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 alert_silence_id = 1; */
        if (message.alertSilenceId !== 0)
            writer.tag(1, WireType.Varint).int64(message.alertSilenceId);
        /* vlp.notification.eAlertSilenceKind kind = 2; */
        if (message.kind !== 0)
            writer.tag(2, WireType.Varint).int32(message.kind);
        /* int64 tenant_id = 3; */
        if (message.tenantId !== 0)
            writer.tag(3, WireType.Varint).int64(message.tenantId);
        /* int64 organization_unit_id = 4; */
        if (message.organizationUnitId !== 0)
            writer.tag(4, WireType.Varint).int64(message.organizationUnitId);
        /* string definition_code_matcher = 5; */
        if (message.definitionCodeMatcher !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.definitionCodeMatcher);
        /* google.protobuf.Timestamp from_at = 6; */
        if (message.fromAt)
            Timestamp.internalBinaryWrite(message.fromAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp to_at = 7; */
        if (message.toAt)
            Timestamp.internalBinaryWrite(message.toAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string reason = 8; */
        if (message.reason !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.reason);
        /* string approved_by = 9; */
        if (message.approvedBy !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.approvedBy);
        /* bool active = 20; */
        if (message.active !== false)
            writer.tag(20, WireType.Varint).bool(message.active);
        /* bool archive = 21; */
        if (message.archive !== false)
            writer.tag(21, WireType.Varint).bool(message.archive);
        /* google.protobuf.Timestamp created_at = 23; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 24; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.AlertSilenceDTO
 */
export const AlertSilenceDTO = new AlertSilenceDTO$Type();
